// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarSection_sectionTitle__Yv\\+Sd {
  font-weight: 400;
  margin-bottom: 0;
  text-transform: uppercase;
}

.SidebarSection_separator__VOnQa {
  margin-top: 2px;
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/SidebarSection/SidebarSection.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF","sourcesContent":[".sectionTitle {\n  font-weight: 400;\n  margin-bottom: 0;\n  text-transform: uppercase;\n}\n\n.separator {\n  margin-top: 2px;\n  margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionTitle": `SidebarSection_sectionTitle__Yv+Sd`,
	"separator": `SidebarSection_separator__VOnQa`
};
export default ___CSS_LOADER_EXPORT___;
